<template>
  <v-btn @click="openDialog" style="margin-top: 20px; width: 100%">Add New School</v-btn>
  <v-dialog v-model="dialog" width="auto">
    <v-card>
      <v-card-title>
        <span>Create School in District</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="School name*"
                  required
                  v-model="school.school_name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  label="District"
                  v-model="school.district_id"
                  variant="outlined"
                  :items="[{ value: district.district_id, title: district.district_name }]"
                  item-value="value"
                  item-title="title"
                  :rules="[rules.required]"
                  density="compact"
                  disabled
                >
                </v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="school.firstname"
                  label="First name*"
                  required
                  hint="Enter first name"
                  :rules="[rules.required]"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="school.lastname"
                  label="Last name*"
                  hint="Enter last name"
                  clearable
                  required
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="Email*"
                  v-model="school.school_contact_email"
                  :rules="[rules.required, rules.email]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="Phone"
                  v-model="school.school_contact_phone"
                  :rules="[rules.min(6)]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="school.username"
                  label="Username*"
                  required
                  autocomplete="username"
                  :name="'school-username'"
                  :rules="[rules.required, rules.min(3)]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="school.password"
                  label="Password"
                  type="password"
                  
                  autocomplete="new-password"
                  :name="'school-password'"
                  :rules="[rules.min(6)]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="school.timezone"
                  :items="timeZones"
                  item-text="text"
                  item-value="value"
                  label="Time Zone*"
                  :rules="[rules.required]"
                  density="compact"
                ></v-select>
              </v-col>
              <!-- <v-col cols="12" sm="6">
                <v-text-field
                  v-model="school.enrollment"
                  label="Student Enrollment"
                  :rules="[rules.required, rules.number]"
                  type="number"
                  step="1"
                ></v-text-field>
              </v-col> -->
              <!--
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="school.subdomain"
                  label="Subdomain"
                  :rules="[
                    rules.min(3),
                    rules.custom(validateDomain, 'Domain is already used by another school')
                  ]"
                ></v-text-field>
              </v-col>
              -->
            </v-row>
          </v-form>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" :disabled="isValidating"  variant="flat" @click="validate(school)">Save School</v-btn>
        <v-btn color="primary" variant="outlined" @click="closeDialog">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.v-card-title {
  background-color: $primary;
  color: white;
}
</style>
<script setup lang="ts">
// import Autocomplete from "@/components/autocomplete.vue";
import type { DistrictCreateSchool, GetSupportDistrict } from "@/api_types/school";
import { useAlertsStore } from "@/stores/alerts";
import useSchools from "@/stores/support/schools";
import { watch, onMounted } from "vue";
import { reactive } from "vue";
import { ref } from "vue";
const props = defineProps<{
  district: GetSupportDistrict;
}>();
// Remove all emits - we'll handle dialog state internally

const alertStore = useAlertsStore();
const schoolStore = useSchools();
const form = ref();
const school = reactive<DistrictCreateSchool>({
  school_name: "",
  district_id: props.district?.district_id || 0,
  firstname: "",
  lastname: "",
  school_contact_email: "",
  school_contact_phone: "",
  username: "",
  password: "",
  // enrollment: 0,
  timezone: "",
  subdomain: ""
});
const isValidating = ref(false);

const setDistrictSchool = () => {
      try {
        if (!props.district || !props.district.district_id) {
          console.log("No valid district provided");
          return;
        }
        
        const districtSchool = schoolStore.getDistrict(props.district.district_id);

        // Only update specific fields if they exist in `districtSchool`
        if (districtSchool) {
          console.log("Updating school object selectively...");
          let firstname = '';
          let lastname = '';
          
          if (districtSchool.school_contact_name) {
            const nameParts = districtSchool.school_contact_name.split(' ');
            firstname = nameParts[0] || '';
            lastname = nameParts.slice(1).join(' ') || '';
          }
          
          Object.assign(school, {
            district_id: props.district.district_id,
            timezone: districtSchool.timezone || '',
            firstname: firstname,
            lastname: lastname,
            school_contact_email: districtSchool.school_contact_email || '',
            school_contact_phone: districtSchool.school_contact_phone || ''
          });
         
          console.log("Updated school object:", school);
        } else {
          console.log("Couldn't find school for district: "+props.district.district_id);
          Object.assign(school, {
            district_id: props.district.district_id
          });
        }
      } catch (error) {
        console.error("Error in setDistrictSchool:", error);
      }
    };
onMounted(() => {
      console.log("Component mounted, initializing school object...");
      setDistrictSchool();
});
watch(
      () => props.district,
      (newDistrict) => {
        if (newDistrict && newDistrict.district_id) {
          console.log("props.district changed, updating school object...");
          setDistrictSchool();
        }
      },
      { immediate: true }
    );
// watch(
//   () => props.district,
//   () => {
//     Object.assign(school, {
//       district_id: props.district.district_id
//     });
//     console.log("getting district school...");
    
//     const districtSchool = schoolStore.getDistrict(props.district.district_id);
//     console.log(districtSchool);


//   }
// );
const usZones = [
  { CountryCode: "US", Timezone: "America/New_York", Description: "Eastern Time" },
  { CountryCode: "US", Timezone: "America/Chicago", Description: "Central Time" },
  { CountryCode: "US", Timezone: "America/Denver", Description: "Mountain Time" },
  { CountryCode: "US", Timezone: "America/Los_Angeles", Description: "Pacific Time" },
  { CountryCode: "US", Timezone: "America/Anchorage", Description: "Alaska Time" },
  { CountryCode: "US", Timezone: "Pacific/Honolulu", Description: "Hawaii Time" }
];

const dialog = ref(false);

const timeZones = ref(usZones.map((zone) => zone.Timezone));
const rules = {
  required: (value) => !!value || "Field is required",
  email: (value) => /.+@.+/.test(value) || "Invalid email address",
  number: (value) => (!isNaN(parseFloat(value)) && isFinite(value)) || "Must be a number",
  min: (min_num: number) => (value: string) =>
    (!value || value.length >= min_num) || `Must be at least ${min_num} characters`,
  custom:
    (func: (value) => boolean, error: string = "Validation Failed") =>
    (value) =>
      func(value) || error
};
const createSchool = async function (school: DistrictCreateSchool) {
  const res = await schoolStore.districtCreateSchool(school);
  if (res.status) {
    alertStore.addAlert("success", "New School Created for District", 5);
  } else {
    alertStore.addAlert(
      "error",
      res.message || "Unknown error please try again in a few minutes or contact support",
      10
    );
  }
  closeDialog();
};

const validate = async (school: DistrictCreateSchool) => {
  isValidating.value = true;
  const { valid } = await form.value.validate();
  if (valid) {
    await createSchool({ ...school, district_id: props.district.district_id });
  } else {
    console.log("invalid form");
  }
  isValidating.value = false;
};

const validateDomain = (subdomain) => {
  return !schoolStore.schools.data.find((i) => i.subdomain == subdomain);
};

const openDialog = () => {
  dialog.value = true;
};

const closeDialog = () => {
  dialog.value = false;
};
</script>
